@let dialogSize = dialogSize$ | async;

<app-dialog [size]="dialogSize">
  <app-dialog-header>Provide or Deny Consent</app-dialog-header>

  @if (data.isRequired && consentStatusControl.value === ConsentValues.OFF && isConsentSubmitted) {
    <div class="alert alert--error mb-6">A selection is required.</div>
  }

  <p class="color-gray-300 mb-6">{{ data.settings.introduction }}</p>

  <mat-radio-group [formControl]="consentStatusControl" class="d-flex flex-column">
    <mat-radio-button class="mb-2" [value]="ConsentValues.AFFIRMATIVE">
      {{ data.settings.affirmativeConsentLanguage }}
    </mat-radio-button>
    <mat-radio-button class="mb-2" [value]="ConsentValues.NEGATIVE">
      {{ data.settings.negativeConsentLanguage }}
    </mat-radio-button>
  </mat-radio-group>

  <app-dialog-footer>
    <button
      andButton
      color="primary"
      type="button"
      [disabled]="!consentStatusControl.value || consentStatusControl.value === ConsentValues.OFF"
      (click)="onSubmitConsent()"
    >
      Submit
    </button>
  </app-dialog-footer>
</app-dialog>
